/* this file is transformed by vux-loader */

/* eslint-disable */
import _toConsumableArray from "D:/we-dev/mobile_v2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js"; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Scroll from '@/components/Scroll/Scroll';
export default {
  name: 'CopyToMe',
  components: {
    Scroll: Scroll
  },
  data: function data() {
    return {
      list: [],
      curPage: 1,
      //当前页
      totalPage: 0,
      //总页数
      pageNum: 20,
      //每页条数
      lx: '2,3',
      pullDownRefresh: {
        threshold: 40,
        // 下拉多少开始刷新
        stop: 20 // 下拉回弹到多少停住

      },
      pullUpLoad: {
        threshold: 25
      },
      isPullDown: false,
      // 正在下拉刷新
      isPullUp: false,
      // 正在上拉加载
      emptyShow: false,
      initFlag: true
    };
  },
  computed: {},
  methods: {
    onPullingDown: function onPullingDown() {
      if (this.isPullDown) return;
      this.isPullDown = true; // 下拉刷新

      this.list = [];
      this.begin = 1;
      this.beginDate = this.$utils.DateUtils.getMonthStart(this.beginDate);
      this.endDate = this.$utils.DateUtils.getMonthEnd(this.endDate);
      this.getMyCopy();
    },
    onPullingUp: function onPullingUp() {
      this.curPage = this.curPage + 1;

      if (this.curPage > this.totalPage) {
        this.updateScroll();
        return;
      }

      if (this.isPullUp) return;
      this.isPullUp = true;
      this.begin = this.begin + this.num;
      this.getMyCopy();
    },
    // 刷新 Scroll 状态
    updateScroll: function updateScroll(flag) {
      this.isPullDown = false;
      this.isPullUp = false;
      this.$refs.scroll.forceUpdate(flag);
    },
    getMyCopy: function getMyCopy() {
      var _this = this;

      this.emptyShow = false;
      this.$utils.Tools.loadShow();
      this.$api.Appr.copymeList({
        pageIndex: this.curPage,
        pageSize: this.pageNum,
        search: {
          // lx: this.lx,
          userSerial: this.$utils.Store.getItem('userSerial')
        }
      }).then(function (response) {
        _this.$utils.Tools.loadHide();

        var code = response.code,
            data = response.data;

        if (+code !== _this.$code.success) {
          if (+code === 605) {
            if (_this.list.length === 0) {
              _this.emptyShow = true;
            }
          }

          _this.updateScroll(false);
        } else {
          var _this$list;

          (_this$list = _this.list).push.apply(_this$list, _toConsumableArray(data.records));

          _this.totalPage = data.totalPage;

          if (_this.list.length === 0) {
            _this.emptyShow = true;
          }

          _this.updateScroll();
        }
      }).catch(function () {
        _this.$utils.Tools.httpError();
      });
    },
    cellClick: function cellClick(xh, type) {
      //type:假类   0 请假；1 出差；2 外出；3 加班；4 调班；5 补出勤; 6 外勤 8销假
      var state = encodeURI(xh + ',3');

      switch (type //genre：类型  1：申请的  2：审批的  3：抄送的
      ) {
        case 0:
          this.$router.push({
            name: 'leaveInfo',
            params: {
              state: state
            }
          });
          break;

        case 1:
          this.$router.push({
            name: 'evectionInfo',
            params: {
              state: state
            }
          });
          break;

        case 2:
          this.$router.push({
            name: 'businessInfo',
            params: {
              state: state
            }
          });
          break;

        case 3:
          this.$router.push({
            name: 'overtimeInfo',
            params: {
              state: state
            }
          });
          break;

        case 4:
          this.$router.push({
            name: 'changeInfo',
            params: {
              state: state
            }
          });
          break;

        case 5:
          this.$router.push({
            name: 'repairInfos',
            params: {
              state: state
            }
          });
          break;

        case 6:
          this.$router.push({
            name: 'legWorkInfo',
            params: {
              state: state
            }
          });
          break;

        case 8:
          this.$router.push({
            name: 'callInfo',
            params: {
              state: state
            }
          });
          break;
      }
    },

    /** 函数function 设定当前页面
     *  wzx
     *  2019.01.09
     **/
    pushHistory: function pushHistory() {
      var state = {
        title: 'title',
        url: ''
      };
      window.history.pushState(state, state.title, state.url);
    }
  },
  created: function created() {
    this.getMyCopy();
  },
  mounted: function mounted() {// this.pushHistory();
    // window.onpopstate = () => {
    //     this.$router.push('/Application')  //输入要返回的上一级路由地址
    // }
  },
  destroyed: function destroyed() {}
};